module.exports = {"gender":{"male":20,"female":33},"age_range":{"0-17":5,"18-24":1,"25-34":26,"35-44":0,"45-54":0,"55-64":0,"65+":20},"returning":{"time6+":3,"time3":1},"Department":[{"id":-1,"count":4},{"id":14,"count":26},{"id":15,"count":44}]}


//////////////////
// WEBPACK FOOTER
// ./src/_mockup/stress_report_select.json
// module id = 1876
// module chunks = 0